"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var nucleus_1 = require("@lifesize/nucleus");
var c = __importStar(require("../constants/calendar"));
var calendarSelectors = __importStar(require("../selectors/calendar"));
var calendar_1 = require("../utils/calendar");
var calendarUpdateInterval = null;
var calendarUpdateIntervalMS = c.CALENDAR_UPDATE_INTERVAL; // Update calendar every 10 seconds
var calendarMiddleware = function (store) { return function (next) { return function (action) {
    // process current action first, then access state for each specific action
    var result = next(action);
    switch (action.type) {
        // This action is received when calendar events are updated
        case nucleus_1.nucleusConstants.WAMP_SUBSCRIPTION_ACTION_CALENDAR_TOPIC: {
            var state = store.getState();
            // NOTE: calendarEnabled is passed through nucleus initialization
            // If not subscribed to calendar service, ignore the rest
            var calendarEnabled = calendarSelectors.getCalendarEnabled(state);
            if (!calendarEnabled)
                break;
            var events = action.payload;
            var unsubscribed = events === c.CALENDAR_NO_SUBSCRIPTION;
            calendar_1.updateCalendarEvents(store, events);
            // If calendar was unsubscribed, clear update interval
            if (calendarUpdateInterval && unsubscribed) {
                clearInterval(calendarUpdateInterval);
                calendarUpdateInterval = null;
            }
            // If calendar is subscribed, set update interval
            else if (!calendarUpdateInterval && !unsubscribed) {
                startInterval(store);
            }
            break;
        }
        case nucleus_1.nucleusConstants.APP_BACKGROUNDED: {
            // Do not need to update the calendar while in the background
            if (calendarUpdateInterval) {
                clearInterval(calendarUpdateInterval);
                calendarUpdateInterval = null;
            }
            break;
        }
        case nucleus_1.nucleusConstants.APP_FOREGROUNDED: {
            var state = store.getState();
            var calendarEnabled = calendarSelectors.getCalendarEnabled(state);
            var calendarUnsubscribed = calendarSelectors.getCalendarUnsubscribed(state);
            // If not subscribed to calendar service, ignore the rest
            if (!calendarEnabled)
                break;
            // If calendar is subscribed, set update interval
            if (!calendarUpdateInterval && !calendarUnsubscribed) {
                startInterval(store);
            }
            break;
        }
        default:
            break;
    }
    return result;
}; }; };
exports.default = calendarMiddleware;
var startInterval = function (store) {
    calendarUpdateInterval = setInterval(function () {
        var state = store.getState();
        var events = calendarSelectors.getCalendarEvents(state);
        calendar_1.updateCalendarEvents(store, events);
    }, calendarUpdateIntervalMS);
};
